// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { navigationListStyles } from "@synd/Overrides/Widgets/Basic/NavigationList";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color } from "@synd/XDL/Utilities";
import { css } from "styled-components";

navigationListStyles.link = {
    typographyProps: {
        ...fontConfig.small,
        css: css`
            letter-spacing: 0;
        `,
    },
};

navigationListStyles.splitter = {
    css: css`
        border-top: 1px solid ${color("common.border")};
        ${({ marginBottom }: any) => `margin-bottom: ${marginBottom}px`}
    `,
};
